export const RATINGS = {
  stars: 4.9,
  reviews: 702,
  patients: 200_000,
} as const
